import { render, staticRenderFns } from "./BrowseDaicho.vue?vue&type=template&id=1b6d40a9&scoped=true&"
import script from "./BrowseDaicho.vue?vue&type=script&lang=js&"
export * from "./BrowseDaicho.vue?vue&type=script&lang=js&"
import style0 from "./BrowseDaicho.vue?vue&type=style&index=0&id=1b6d40a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6d40a9",
  null
  
)

export default component.exports